export type GoogleConsentState = 'denied' | 'granted'

export interface GoogleConsentModeDefaults {
  ad_personalization: GoogleConsentState
  ad_storage: GoogleConsentState
  ad_user_data: GoogleConsentState
  analytics_storage: GoogleConsentState
  functionality_storage: GoogleConsentState
  personalization_storage: GoogleConsentState
  security_storage: GoogleConsentState
  wait_for_update: number
}

interface GoogleConsentWindow extends Window {
  awGoogleConsentDefaultsInitialized?: boolean
  dataLayer: unknown[][]
  gtag?: (...args: unknown[]) => void
}

export const GOOGLE_CONSENT_MODE_DEFAULTS: GoogleConsentModeDefaults = {
  ad_personalization: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'denied',
  personalization_storage: 'denied',
  security_storage: 'granted',
  wait_for_update: 500
}

/**
 * Ensures Google Consent Mode defaults exist before Google tags are initialized via Segment.
 * @param {Window} [targetWindow=window] Browser window used for bootstrapping consent defaults.
 */
export function ensureGoogleConsentModeDefaults(targetWindow: Window = window): void {
  const consentWindow = targetWindow as GoogleConsentWindow

  if (consentWindow.awGoogleConsentDefaultsInitialized) {
    return
  }

  consentWindow.dataLayer = Array.isArray(consentWindow.dataLayer) ? consentWindow.dataLayer : []
  consentWindow.gtag =
    typeof consentWindow.gtag === 'function'
      ? consentWindow.gtag
      : (...args: unknown[]) => {
          consentWindow.dataLayer.push(args)
        }

  consentWindow.gtag('consent', 'default', GOOGLE_CONSENT_MODE_DEFAULTS)
  consentWindow.awGoogleConsentDefaultsInitialized = true
}
